<template>
  <b-row>
    <b-col cols="12" sm="6" md="4">
      <BfInput
        label="Nº de Encargo"
        data-key="encargos_numero"
        :value="data.encargos_numero"
        :errors="errors"
        readonly
      />
    </b-col>

    <b-col cols="12" sm="6" md="4">
      <BfInput
        label="Cliente"
        data-key="encargos_empresa_cliente_nombre"
        :value="data.encargos_empresa_cliente_nombre"
        :errors="errors"
        readonly
      />
    </b-col>

    <b-col cols="12" sm="6" md="4">
      <BfDatePicker
        label="Fecha alta"
        data-key="fecha_hora_creacion"
        :value="data.fecha_hora_creacion"
        value-format="yyyy-MM-dd HH:mm:ss"
        @update="updateForm"
        :errors="errors"
      />
    </b-col>

    <!--segunda fila-->

    <b-col cols="12" sm="6" md="4">
      <BfSelect
        label="Tipo"
        data-key="tipo"
        :value="data.tipo"
        :edit-mode="editing"
        :errors="errors"
        :options="typeSelectOptions"
        @update="updateForm"
      />
    </b-col>

    <b-col cols="12" sm="6" md="4">
      <BfSwitch
        label="Notificada"
        data-key="notificada"
        :value="data.notificada"
        @update="updateForm"
      />
    </b-col>

    <b-col cols="12" sm="6" md="4">
      <BfSelect
        label="Tasador encargado"
        data-key="tasador_asignado_id"
        :value="data.tasador_encargado_nombre"
        :edit-mode="editing"
        :errors="errors"
        :options="assessorSelectOptions"
        @update="updateForm"
      />
    </b-col>

    <b-col cols="12">
      <BfInput
        label="Descripción"
        data-key="descripcion"
        :value="data.descripcion"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
        type="textarea"
        :autosize="{ minRows: 3, maxRows: 10 }"
      />
    </b-col>

    <b-col cols="12" md="4">
      <BfCheckbox
        label="Resuelta"
        data-key="estado"
        :value="data.estado"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="12" md="4">
      <BfCheckbox
        label="Inactiva"
        data-key="inactivo"
        :value="data.inactivo"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col v-if="isResolved" cols="4">
      <!-- {{data.fecha_hora_resolucion}} -->
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'IncidentForm',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    editing: {
      type: Boolean,
      default: false,
    },

    errors: {
      type: Object,
    },

    assessorSelectOptions: {
      type: Array,
    },

    typeSelectOptions: {
      type: Array,
    },
  },

  methods: {
    updateForm(fieldData) {
      this.$emit('update', fieldData);
    },
  },

  computed: {
    isResolved() {
      return this.data.estado === 1;
    },
  },
};
</script>
